import { OptionModel } from "services/models/model";
import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";

export class TradeUnionModel extends Model implements IModel<TradeUnionModel> {
  code: string = "";
  name: string = "";
  description: string = "";
  enable: boolean = true;
  companyGroupId: string | undefined = undefined;

  static create(input: any): TradeUnionModel {
    return ObjectMapper.deserialize<TradeUnionModel>(TradeUnionModel, input);
  }

  toOption(): OptionModel {
    return {
      label: `${this["code"]} - ${this["name"]}`,
      value: this.id,
    } as OptionModel;
  }
}
